
// react-bootstrap imports
import { useState, useRef } from "react"
import { Button, Form } from "react-bootstrap"

// components imports
import { LoadingSpinner } from "components/Helpers"
import { SenhaInput, TextInput } from "components/Inputs"
import { BotaoLogarAdmin } from "components/BotoesAuxiliaresDev"
import { ErrorChamadaApiMessage, WarningIncompleteInput } from "components/AlertMessages"

import { getFormData } from "services/FormFunctions"
import { ValidateLoginFuncionario } from "services/CallAPIs"
import { registerUser, userLogado } from "services/LoginFunctions"

import stdStyle from "json/StdStyles.json"

function userIsValid(userData)
{
    if (400 <= userData.status) { return false }

    return userData !== null
}

const UserNotFoundMessage = () => <><div className="mt-3 fw-bold">Ops, não te achei!</div><div>Você está cadastrado no sistema?</div></>

export function EntrarScreen()
{
    const [attemptedLogin, setAttemptedLogin] = useState(false)
    const [warnings, setWarnings] = useState({matricula: "", senha: ""})
    const [isLoading, setLoading] = useState(false)
    const [showAlertInputsAreNotValid, setShowAlertInputsAreNotValid] = useState(false)
    const [showErrorLogin, setShowErrorLogin] = useState(false)
    const target = useRef(null)

    const submitForm = async event =>
    {
        event.preventDefault()
        const form = event.currentTarget
        const formData = getFormData(form)
        
        if (!form.checkValidity())
        {
            setShowAlertInputsAreNotValid(true)
        }
        if (!form.checkValidity()) { return }

        setLoading(true)
        try
        {
            const userData = await ValidateLoginFuncionario(formData, setShowErrorLogin)

            if (!userIsValid(userData)) { return }
            
            registerUser(userData)
            window.location.href="/"
        }
        catch (error)
        {
            // alert("Erro ao tentar encontrar usuário")
        }
        finally 
        {
            setAttemptedLogin(true)
            setLoading(false)
        }
    }

    function checkMatricula()
    {
        setWarnings({matricula: "", senha: warnings.senha})
        if (document.getElementsByName("matricula")[0].value.length !== 6)
        {
            setWarnings({matricula: "A matrícula costuma ter 6 caracteres", senha: warnings.senha}) 
        }
    }

    return (
        <>

            <WarningIncompleteInput show={showAlertInputsAreNotValid} setShow={setShowAlertInputsAreNotValid} />
            <ErrorChamadaApiMessage apiName={"Login"} show={showErrorLogin} setShow={setShowErrorLogin} />

            <Form className={stdStyle.form} noValidate onSubmit={submitForm}>
                
                <TextInput Name={"matricula"} Placeholder={"000000"} Label={"Matrícula"} Req={true} Warn={warnings.matricula} OnBlur={checkMatricula} />
                <SenhaInput Name={"senha"} Placeholder={"******"} Label={"Senha"} Req={true} Warn={warnings.senha} Info={"Use sua senha do urb docs"} /> 

                <Button className="mt-3" type="submit" ref={target}>Entrar</Button>
                <BotaoLogarAdmin target={target} />
                
                {attemptedLogin && !userLogado ? <UserNotFoundMessage /> : <></>}

            </Form>

            <LoadingSpinner show={isLoading} />
            
        </>
    )

}